$(document).on ('ajax:error', '#machine_control_form', (event) => {
  data = event.detail[0], http_status = event.detail[1], xhr = event.detail[2]
  form = $('#machine_control_form')
  alert = '<div id="machine-control-error" class="alert alert-danger alert-dismissable" role="alert">'
  alert = alert + '<button class="btn-close" type="button" data-bs-dismiss="alert" aria-label="Close"></button>'
  $.each(data.errors, (idx, msg) => {
    alert = alert + `<strong>・${msg}</strong><br>`
  })
  alert = alert + '</div>'

  if ($('#machine-control-error')[0]) {
    $('#machine-control-error').remove()
    form.prepend(alert)
  } else {
    form.prepend(alert)
  }
})

var monitor_timer

setMonitorTimer = () => {
  monitor_timer = setTimeout(function() {
    location.reload()
  }, 60000)
}

clearMonitorTimer = () => {
  if (monitor_timer != null) {
    clearTimeout(monitor_timer)
    monitor_timer = null
  }
}

$(document).on('turbolinks:load', function() {
  if ($('#room-monitor').length) {
    setMonitorTimer()
  }
})

$(document).on('turbolinks:before-visit', function() {
  if ($('#room-monitor').length) {
    clearMonitorTimer()
  }
})

$(document).on('show.bs.modal', '#machine-control-modal', () => {
  if ($('#room-monitor').length) {
    clearMonitorTimer()
  }
})

$(document).on('hidden.bs.modal', '#machine-control-modal', () => {
  if ($('#room-monitor').length) {
    setMonitorTimer()
  }
})
